import './storeProfileView.scss';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utils/constants/routesConstants';

import InfoPanel from '@/components/common/InfoPanel/InfoPanel';

// Sections
import CustomerInformation from '@/containers/Store/ProfileView/sections/CustomerInformation';
import DeliveryData from '@/containers/Store/ProfileView/sections/DeliveryData';
import StoreInformation from '@/containers/Store/ProfileView/sections/StoreInformation';
import SegmentInformation from '@/containers/Store/ProfileView/sections/SegmentInformation';

const ProfileView = () => {
  const { storeData } = useOutletContext();
  const navigate = useNavigate();

  /**
   * Handles navigation to the customer view page when a customer ID is clicked
   * This function takes a customer ID and navigates to the customer view route
   * by replacing the :customerId parameter in the route with the actual ID
   *
   * @param {string} customerId - The ID of the customer to view
   */
  const handleCustomerClick = customerId => {
    navigate(ROUTES.CUSTOMER_VIEW.replace(':customerId', customerId));
  };

  return (
    <div>
      <InfoPanel
        title='Store Information'
        isCollapsible={true}
        defaultOpen={true}>
        <StoreInformation storeData={storeData} />
        <CustomerInformation
          storeData={storeData}
          handleCustomerClick={handleCustomerClick}
        />
        <DeliveryData storeData={storeData} />
      </InfoPanel>
      <SegmentInformation storeData={storeData} />
    </div>
  );
};

export default ProfileView;
